import { asBoolean, asDate, asString, isObject } from "./model-utils";

export class BankAccount {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.id = asString(json._id || json.id);
    this.accountNo = asString(json.accountNo);
    this.accountName = asString(json.accountName);
    this.bankName = asString(json.bankName);
    this.bankCode = asString(json.bankCode);
    this.country = asString(json.country);
    this.currency = asString(json.currency);
    this.iBanNo = asString(json.iBanNo);
    this.branchName = asString(json.branchName);
    this.enabled = asBoolean(json.enabled);
    this.primary = asBoolean(json.primary);
    this.accountId = asString(json.accountId);
    this.accountCode = asString(json.accountCode);
    this.countryCode = asString(json.countryCode);
    this.branchCode = asString(json.branchCode);
    this.swiftCode = asString(json.swiftCode);
    this.intermediaryBank = asString(json.intermediaryBank);
    this.intermediaryBankName = asString(json.intermediaryBankName);
    this.bankAddress = asString(json.bankAddress);
    this.accountExpiresAt = asDate(json.accountExpiresAt);
  }

  static fromJson(json: any) {
    return isObject(json) ? new BankAccount(json) : json;
  }
}
